<template>
	<div class="col-12 pl-0 pr-0">
		<div class="col-12 pl-0 pr-0">
			<transition name="slide-fade">
				<div class="col-12 pl-4 pr-4 pt-4 pb-2 bg-white cus-box-shadow rounded-cus d-flex flex-wrap">
					<div class="col-lg-12 pl-0 pr-0">
						<div class="col-12 pl-0 pr-0 pb-1 font-size-13 font-weight-bold">
							Ringkasan Detail Transaksi
						</div>
						<!-- <div class="col-12 pl-0 pr-0 pt-3 pb-1">
							<div class="col-12 pl-0 pr-0 pt-1 pb-1">
                                <div>responsePayment : </div>
                                <div>{{ responsePayment }}</div>
							</div>
                            <div>
                                <div>selectedPayment : </div>
                                <div>{{ selectedPayment }}</div>
                            </div>
                            <div>
                                <div>selectedPaymentValue : </div>
                                <div>{{ selectedPaymentValue }}</div>
                            </div> 
						</div> -->
						<div class="col-12 pl-0 pr-0 pt-3 pb-1 d-flex flex-wrap" v-if="selectedPayment.value == '1'">
							<div class="col-lg-6 pl-0 pr-0 pt-1 pb-1">
								<div class="mb-3">
									<div>Kode Transaksi</div>
									<div class="font-size-12 font-weight-bold">{{ responsePayment.data.so_code }}</div>
								</div>
								<div class="mb-3">
									<div>Transfer Pembayaran</div>
									<div><img :src="responsePayment.data.payment_bank.bank_image" width="100"></div>
									<div class="font-size-12 font-weight-bold">
										{{ responsePayment.data.payment_bank.bank_account_number }}
										<button class="btn bg-blue color-white ml-1"
											@click="copyText(responsePayment.data.payment_bank.bank_account_number)"><i
												class="fa fa-copy"></i></button>
									</div>
									<div class="font-size-10">{{ responsePayment.data.payment_bank.bank_account_name }}</div>
								</div>
								<div class="mb-3">
									<div>Jumlah Yang Harus Dibayar</div>
									<div class="font-weight-bold">Rp {{ responsePayment.data.payment_total }}</div>
								</div>
							</div>
							<div class="col-lg-6 pl-0 pr-0 pt-1 pb-1">
								<div class="row">
									<div class="col-12 text-center color-black">
										Sisa Waktu Pembayaran
									</div>
								</div>
								<div class="row">
									<div class="col-12 text-center font-size-20 color-black f-lato">
										<span> {{ hours | two_digits }} </span> : <span> {{ minutes | two_digits }} </span> : <span> {{ seconds |
											two_digits }} </span>
									</div>
								</div>
								<div class="row">
									<div class="col-12 text-center color-black">
										<span class="pr-1 pl-3">Jam</span><span class="pr-1 pl-3">Menit</span><span
											class="pr-1 pl-3">Detik</span>
									</div>
								</div>
								<div class="row">
									<div class="col-12 text-center font-size-11 font-size-sm-10 color-black pt-2 f-lato">
										(Sebelum {{ responsePayment.data.payment_bank.bank_expired | hariTanggalJam }})
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-1 d-flex flex-wrap" v-if="selectedPayment.value == '2'">
							<div class="col-lg-6 pl-0 pr-0 pt-1 pb-1">
								<div class="mb-3">
									<div>Kode Transaksi</div>
									<div class="font-size-12 font-weight-bold">{{ responsePayment.data.so_code }}</div>
								</div>
								<div class="mb-3">
									<div>Transfer Pembayaran</div>
									<div><img :src="responsePayment.data.payment_va.va_bank_image" width="100"></div>
									<div class="font-size-12 font-weight-bold">
										{{ responsePayment.data.payment_va.va_number }}
										<button class="btn bg-blue color-white ml-1"
											@click="copyText(responsePayment.data.payment_va.va_number)"><i class="fa fa-copy"></i></button>
									</div>
								</div>
								<div class="mb-3">
									<div>Jumlah Yang Harus Dibayar</div>
									<div class="font-weight-bold">Rp {{ responsePayment.data.payment_total }}</div>
								</div>
							</div>
							<div class="col-lg-6 pl-0 pr-0 pt-1 pb-1">
								<div class="row">
									<div class="col-12 text-center color-black">
										Sisa Waktu Pembayaran
									</div>
								</div>
								<div class="row">
									<div class="col-12 text-center font-size-20 color-black f-lato">
										<span> {{ hours | two_digits }} </span> : <span> {{ minutes | two_digits }} </span> : <span> {{ seconds |
											two_digits }} </span>
									</div>
								</div>
								<div class="row">
									<div class="col-12 text-center color-black">
										<span class="pr-1 pl-3">Jam</span><span class="pr-1 pl-3">Menit</span><span
											class="pr-1 pl-3">Detik</span>
									</div>
								</div>
								<div class="row">
									<div class="col-12 text-center font-size-11 font-size-sm-10 color-black pt-2 f-lato">
										(Sebelum {{ responsePayment.data.payment_va.va_expired | hariTanggalJam }})
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-1 d-flex flex-wrap" v-if="selectedPayment.value == '3'">
							<div class="col-lg-6 pl-0 pr-0 pt-1 pb-1">
								<div class="mb-3">
									<div>Kode Transaksi</div>
									<div class="font-size-12 font-weight-bold">{{ responsePayment.data.so_code }}</div>
								</div>
							</div>
							<div class="col-lg-6 pl-0 pr-0 pt-1 pb-2 mb-2 d-md-flex justify-content-md-end flex-wrap align-items-center">
								<div class="row">
									<div class="col-12 mr-2 color-black">
										Sisa Waktu Pembayaran
									</div>
								</div>
								<div class="row">
									<div class="col-12 font-size-20 color-black f-lato">
										<span> {{ hours | two_digits }} </span> : <span> {{ minutes | two_digits }} </span> : <span> {{ seconds |
											two_digits }} </span>
									</div>
								</div>
								<div class="row">
									<div class="col-12 font-size-11 font-size-sm-10 color-black pt-0 f-lato">
										(Sebelum {{ responsePayment.data.payment_split.bank_expired | hariTanggalJam }})
									</div>
								</div>
							</div>
							<div v-for="(paymentSplit, index) in (responsePayment.data.payment_split.payment_data)" :key="index"
								class="col-lg-12 pl-0 pr-0 pt-1 pb-1 cus-box-shadow rounded-cus font-size-10 d-flex mb-3">
								<!-- <div
									class="col-12 pl-md-4 pr-md-4 pt-2 pb-2 bg-blue mt-3 mb-3 color-white cus-box-shadow rounded-cus font-size-10 d-flex">
									<div class="pl-2">Order akan diproses pada jam operasional.</div>
								</div> -->
								<div class="col-lg-12 pt-1 pb-1 d-flex flex-wrap justify-content-between align-items-center">
									<div>
										<span class="font-weight-bold">Transfer Pembayaran</span>
										<div><img :src="paymentSplit.bank_image" width="100"></div>
										<div class="font-size-12 font-weight-bold">
											{{ paymentSplit.bank_account_number }}
											<button class="btn bg-blue color-white ml-1" @click="copyText(paymentSplit.bank_account_number)"><i
													class="fa fa-copy"></i></button>
										</div>
										<div class="font-size-10">{{ paymentSplit.bank_account_name }}</div>
									</div>
									<div class="d-none d-md-block"><i class="fas fa-long-arrow-alt-left"></i></div>
									<div class="mt-2 mt-md-0">
										<span class="font-weight-bold">Bayar dengan Transfer Bank</span>
										<div><img :src="paymentSplit.customer_transfer_bank_image" width="100"></div>
										<div>Jumlah Yang Harus Dibayar</div>
										<div class="font-weight-bold font-size-12">{{ paymentSplit.bank_amount | toRupiah }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	components: {
	},
	data() {
		return {
			now: Math.trunc((new Date()).getTime() / 1000)
		}
	},
	computed: {
		...mapState('po_cart', ['cart', 'step', 'responsePayment', 'selectedPayment', 'selectedPaymentValue']),

		dateInMilliseconds() {
			return Math.trunc(Date.parse(this.date) / 1000)
		},
		seconds() {
			if (this.date) {
				return (this.dateInMilliseconds - this.now) % 60;
			}
			else {
				return 59
			}
		},
		minutes() {
			if (this.date) {
				return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
			}
			else {
				return 59
			}
		},
		hours() {
			if (this.date) {
				return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60);
			}
			else {
				return 23
			}

			// return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
		},
		days() {
			return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
		},
		date() {
			if (this.selectedPayment.value == '1') {
				return this.responsePayment.data.payment_bank.bank_expired
			} else if (this.selectedPayment.value == '2') {
				return this.responsePayment.data.payment_va.va_expired
			} else {
				return this.responsePayment.data.payment_split.bank_expired
			}
		}
	},
	methods: {
		copyText(text) {
			navigator.clipboard.writeText(text)
			alert("Teks berhasil disalin")
		}
	},
	created() {
	},
	mounted() {
		window.setInterval(() => {
			this.now = Math.trunc((new Date()).getTime() / 1000);
		}, 1000);
	},
	watch: {

	}
};
</script>